export interface IRemoteData {
    _t: string
}

export interface AvailableSeriesData extends IRemoteData {
    LineSeries: Array<string>;
    BarSeries: Array<string>;
}

export interface MachineStructureData extends IRemoteData {
    Structure?: string | null;
}

export interface SeriesUpdateData extends IRemoteData {
    SeriesName: string;
    Data: Array<any>;
    LastTime: number;
}

export interface RmtPropertyUpdate {
    Id: number;
    Value?: any | null;
}

export interface RmtPropertyUpdates extends IRemoteData {
    Data: Array<RmtPropertyUpdate>;
}

export interface SupplierStateMessage extends IRemoteData {
    IsActive?: boolean;
}

export interface RemoteDataMessage {
    Data: IRemoteData;
}

export interface ClientRemoteDataRequest { 
    DataSeries?: Array<string> | null;
    MachineDataUpdates?: boolean;
}

export interface ClientFunctionCallRequest { 
    FunctionId?: number;
    Guid?: string;
    Arguments?: Array<any> | null;
    Action?: ObjectAction | null;
}

export interface ObjectAction { 
    readonly Target?: any | null;
    readonly Method?: any | null;
}



export const typeGuards: Record<string, (input: IRemoteData) => boolean> = {
    AvailableSeriesData: (input: IRemoteData): input is AvailableSeriesData =>
        Array.isArray((input as AvailableSeriesData).LineSeries) &&
        Array.isArray((input as AvailableSeriesData).BarSeries),

    MachineStructureData: (input: IRemoteData): input is MachineStructureData =>
        "Structure" in input &&
        (typeof (input as MachineStructureData).Structure === "string" ||
            (input as MachineStructureData).Structure === null ||
            (input as MachineStructureData).Structure === undefined),

    SeriesUpdateData: (input: IRemoteData): input is SeriesUpdateData => 
        typeof (input as SeriesUpdateData).SeriesName === "string" &&
        Array.isArray((input as SeriesUpdateData).Data) &&
        typeof (input as SeriesUpdateData).LastTime === "number",

    RmtPropertyUpdates: (input: IRemoteData): input is RmtPropertyUpdates =>
        Array.isArray((input as RmtPropertyUpdates).Data) &&
        (input as RmtPropertyUpdates).Data.every(
            (item) =>
                typeof item.Id === "number" &&
                (item.Value === null || typeof item.Value !== "undefined")
        ),

    SupplierStateMessage: (input: IRemoteData): input is SupplierStateMessage =>
        "IsActive" in input &&
        (typeof (input as SupplierStateMessage).IsActive === "boolean" ||
            (input as SupplierStateMessage).IsActive === undefined),
};

export function getIRemoDataType(input: any): string {

    var data = input as any;
    // prefilter decide if MessagePack or json
    if (Array.isArray(data) && data.length == 2) {
        data = data[1] as IRemoteData;

    } else if (data.hasOwnProperty("_t")) {
        data = data as IRemoteData;
    } else {
        console.warn(`Unknown Data: ${JSON.stringify(data)}`);
        return "unknown";
    }

    return data._t;
}

export function cast<T extends IRemoteData>(
    input: IRemoteData
): T | null {
    var data = input as any;
    // prefilter decide if MessagePack or json
    if (Array.isArray(data) && data.length == 2) {
        data = data[1] as IRemoteData;

    } else if (data.hasOwnProperty("_t")) {
        data = data as IRemoteData;
    } else {
        console.warn(`Unknown Data: ${JSON.stringify(data)}`);
        return null;
    }

    const guard = typeGuards[data._t];
    if (guard && guard(data)) {
        return data as T; // Cast to the inferred type
    }
    console.warn(`Object does not match the type for _t: ${input._t}`);
    return null;
}



